// TODO We do not need that package...there are enough util function to easily make that happen!
import coords from 'formatcoords'
import * as Number from './number'

export function format(longitude, latitude, precision = 6, dms = false) {
    const format = dms ? 'FFf' : 'f'
    const decimalPlaces = dms ? precision - 2 : precision

    return coords(latitude, longitude).format(format, { decimalPlaces })
}

export function isValidLatitude(latitude) {
    return Number.isValid(latitude) && latitude <= 90 && latitude >= -90
}

export function isValidLongitude(longitude) {
    return Number.isValid(longitude) && longitude <= 180 && longitude >= -180
}
